function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export var NoodleModalTemplates = {
  action: {
    "delete": function _delete(_ref) {
      var entityName = _ref.entityName,
        deleteActual = _ref.deleteActual,
        onAfterDelete = _ref.onAfterDelete;
      var modalTitle = "Delete: ".concat(entityName);
      var deleteMsg = "Are you sure you want to delete this ".concat(entityName, "?");
      return {
        title: modalTitle,
        secondary: {},
        primary: _objectSpread(_objectSpread({}, NoodleModalTemplates.button["delete"]), {}, {
          __do: function __do(idx, ops) {
            ops.setIsProcessing(true);
            deleteActual({
              returnResponse: function returnResponse(response) {
                var _response$http, _response$http2;
                var ok = (response === null || response === void 0 || (_response$http = response.http) === null || _response$http === void 0 ? void 0 : _response$http.code) > 199 && ((_response$http2 = response.http) === null || _response$http2 === void 0 ? void 0 : _response$http2.code) < 300;
                ops.setIsProcessing(false);
                ops.onAfterDo(response, function () {
                  onAfterDelete({
                    modalIndex: idx,
                    isSuccessful: ok
                  });
                }, {
                  primary: {
                    label: "OK",
                    icon: "check",
                    nature: "neutral"
                  }
                });
              }
            });
          }
        })
      };
    }
  },
  button: {
    "delete": {
      label: "Delete",
      icon: "trash-2",
      nature: "negative"
    },
    remove: {
      label: "Remove",
      icon: "trash-2",
      nature: "negative"
    },
    ok: {
      label: "OK",
      icon: "check",
      nature: "INFO"
    },
    no: {
      label: "No"
    },
    yes: {
      icon: "check",
      label: "Yes"
    },
    logout: {
      label: "Logout",
      icon: 'log-out',
      nature: "negative"
    }
  }
};